module.exports = __webpack_public_path__ + "img/minoxidil.f22d8478.png";